import { render, staticRenderFns } from "./CreateProjectEmail.vue?vue&type=template&id=7c12d915&scoped=true&"
import script from "./CreateProjectEmail.vue?vue&type=script&lang=js&"
export * from "./CreateProjectEmail.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectEmail.vue?vue&type=style&index=0&id=7c12d915&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c12d915",
  null
  
)

export default component.exports